export default {"src":"/_next/static/media/ollie-tail-wag.b8559c22.svg","height":185,"width":141,"blurWidth":0,"blurHeight":0};